import { createStores } from 'app/store';

export function initStores(dehydratedState: unknown) {
    const { mobxStores, bootstrap } = createStores(dehydratedState);
    void bootstrap();
    return mobxStores;
}
